import { Link } from "react-router-dom";
import { ArrowLeft, Sparkles } from "lucide-react";
import { SiteShell } from "@/components/layout/SiteShell";
import WaitlistCapture from "@/components/marketplace/WaitlistCapture";

export default function ComingSoon({ title, description, sections = [], eta = "", waitlist }) {
  return (
    <SiteShell>
      <section className="container-page py-20 md:py-28" data-testid="coming-soon-root">
        <div className="max-w-2xl">
          <Link to="/" className="inline-flex items-center gap-1.5 text-sm text-muted-foreground hover:text-foreground mb-8 group"
            data-testid="back-to-home-top">
            <ArrowLeft size={14} className="transition-transform group-hover:-translate-x-0.5" />
            Back to home
          </Link>
          <span className="chip-gold"><Sparkles size={14} /> Coming soon{eta ? ` · ${eta}` : ""}</span>
          <h1 className="mt-4 font-serif text-4xl md:text-5xl tracking-tight">{title}</h1>
          <p className="mt-5 text-base sm:text-lg text-muted-foreground leading-relaxed">
            {description}
          </p>

          {waitlist && (
            <WaitlistCapture
              source={waitlist.source}
              headline={waitlist.headline}
              subhead={waitlist.subhead}
            />
          )}

          {sections.length > 0 && (
            <div className="mt-10 grid sm:grid-cols-2 gap-4">
              {sections.map((s) => (
                <article
                  key={s.title}
                  id={s.id}
                  className="rounded-2xl border bg-[hsl(var(--sb-surface))] p-5"
                >
                  <h3 className="font-serif text-xl text-[hsl(var(--sb-forest-2))]">{s.title}</h3>
                  <p className="mt-2 text-sm text-muted-foreground leading-relaxed">
                    {s.body}
                  </p>
                </article>
              ))}
            </div>
          )}

          <Link to="/" className="btn-primary mt-10 inline-flex" data-testid="back-to-home-bottom">
            <ArrowLeft size={14} /> Back to home
          </Link>
        </div>
      </section>
    </SiteShell>
  );
}
